module.exports = __webpack_public_path__ + "static/img/0544_7.5c8d482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_7.jpg
// module id = hr/0
// module chunks = 1